import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./league.css";
import Popup from 'reactjs-popup';
import LocationModal from './modals/LocationModal/LocationModal';
import TimeModal from './modals/TimeModal/TimeModal';
import back from '../../../../../../assets/arrow-back.svg';
import calendar from '../../../../../../assets/calendar-icon.svg';
import DaysModal from './modals/DaysModal/DaysModal';
import axiosApi from '../../../../../../core/interceptor/interceptor';
import { config } from '../../../../../../config';
import CustomSelect from '../../../../../../Util/CustomSelect/CustomSelect';
import moment from 'moment';
import { capitaLizeString, GENDER, HOSTED_BY, PLAYER_TYPE, REMINDER_TYPE, YES_NOT_LABEL, YES_NOT_TYPE } from '../../../../../../Util/helper';
import SeasonPopup from '../../SeasonPopup/Season'
import { messages } from '../../../../../../messages';
import _ from 'lodash';
import LeagueLocationScheduleSection from '../../Common/LeagueLocationScheduleSection';
import Timepicker from '../../../../../../Util/Timepicker/Timepicker';
import plusSvg from '../../../../../../assets/plus-icon.svg';
import minusSvg from '../../../../../../assets/minus-pri.png';
export default function League(props) {
  const [modalContent, setModalContent] = useState('');
  const [open, setOpen] = useState(false);
  const [sports, setSports] = useState([]);
  const [playLevel, setPlayLevel] = useState([]);
  const [teamSize, setTeamSize] = useState([]);
  const [gender, setGender] = useState([]);
  const [daysPlayed, setDaysPlayed] = useState([]);
  const [eliminationType, setEliminationType] = useState([]);
  const [hostedBy, setHostedBy] = useState([]);
  const [payload, setPayload] = useState({ name: '', season_id: '', season_name: '', type: '' });
  const [type, setType] = useState(null);
  const history = useHistory();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [leagueScheduleInfo, setLeagueScheduleInfo] = useState([]);
  const search = useLocation().search;
  const season_id = new URLSearchParams(search).get('season_id');

  useEffect(() => {
    getMiscLeagues();
    getSports();
    if (props.location && props.location.state && props.location.state.type === 'edit') {
      getLeague(props.location.state.league_id);
    } else {
      setPayload({
        season_id: props && props.location && props.location.state && props.location.state.season_id ? props.location.state.season_id : 0,
        season_name: props && props.location && props.location.state && props.location.state.season_name ? props.location.state.season_name : '',
        type: props && props.location && props.location.state && props.location.state.type ? props.location.state.type : '',
      });
    }
    //eslint-disable-next-line
    getLevelOfPlay();
  }, []);

  const getSports = () => {
    axiosApi.get(`${config.apiUrl}/sports`)
      .then((resp) => {
        if (resp.data && resp.data.data) {
          setSports(resp.data.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const getMiscLeagues = () => {
    axiosApi.get(`${config.apiUrl}/misc/static/leagues`)
      .then((resp) => {
        if (resp.data && resp.data.data) {
          const data = resp.data.data;
          if (data.play_level) {
            // setPlayLevel(data.play_level);
          }
          if (data.team_size) {
            const count = [];
            if (data.team_size > 0) {
              for (let index = 1; index <= data.team_size; index++) {
                count.push({ id: index, title: index });
              }
            }
            setTeamSize(count);
          }
          if (data.gender) {
            setGender(data.gender);
          }
          if (data.days_played) {
            setDaysPlayed(data.days_played.map(day => ({ day, indv_reg_allow: false })));
          }
          if (data.elimination_type) {
            setEliminationType(data.elimination_type);
          }
          if (data.hosted_by) {
            setHostedBy(data.hosted_by);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const loadModalContent = (type) => {
    setType(type);
    const modal = {
      location: (
        <LocationModal
          closeModal={handleModalCloseResponse}
          selectedData={payload && Array.isArray(payload.location) ? payload.location : []}
        />
      ),
      time_slots: <TimeModal closeModal={handleModalCloseResponse} selectedData={payload && Array.isArray(payload.time_slots) ? payload.time_slots : []} />,
      days_played: (() => {
        const list = _.cloneDeep(daysPlayed);
        if (payload.days_played && Array.isArray(payload.days_played)) {
          list.forEach(day => {
            const obj = payload.days_played.find(selDay => selDay.day === day.day);
            if (obj) {
              day.checked = true;
              day.indv_reg_allow = obj.indv_reg_allow;
            }
          });
        }
        return <DaysModal data={list} closeModal={handleModalCloseResponse} />
      })(),
      change_season: <SeasonPopup closeModal={(e) => {
        if (e) {
          setPayload((prevData) => ({
            ...prevData,
            season_id: e.id,
            season_name: e.name,
          }));
        }
        setOpen(false);
      }} NotShowAll={true} />,
    }
    setModalContent(modal[type]);
  }

  const popupHandler = (event, type) => {
    event.preventDefault();
    loadModalContent(type);
    setOpen(o => !o);
  }

  const onSelect = (data, type) => {
    if (data && data.title) {
      handleModalCloseResponse({ type, data: ['sport', 'sport_id', 'status', 'hosted_by'].includes(type) ? data.id : data.title });
    }
  }

  const handleModalCloseResponse = (resp) => {
    if (resp) {
      setPayload(prevData => ({
        ...prevData,
        [resp.type]: resp.data,
      }));
    }
    setOpen(false);
  }
  const handleSaveLeague = () => {
    setFormSubmitted(true);
    const data = {
      sport_id: payload.sport_id,
      season_id: payload.season_id,
      name: payload.name?.trim(),
      reg_deadline: moment(payload.reg_deadline).format('YYYY-MM-DD'),
      start_date: moment(payload.start_date).format('YYYY-MM-DD'),
      reg_fees: Number(payload.reg_fees || 0),
      for_feit_fees: Number(payload.for_feit_fees || 0),
      team_size: Number(payload.team_size),
      play_level: payload.play_level,
      gender: payload.gender === 'Male' ? 'M' : payload.gender === 'Female' ? 'F' : 'C',
      men_per_team: Number(payload.men_per_team),
      women_per_team: Number(payload.women_per_team),
      time_slots: payload.time_slots && payload.time_slots.length ? payload.time_slots.join(',') : '',
      days_played: payload.days_played && payload.days_played.length ? payload.days_played : null,
      elimination_type: payload.elimination_type,
      hosted_by: payload.hosted_by,
      no_of_weeks: Number(payload.no_of_weeks || 0),
      no_of_games: Number(payload.no_of_games || 0),
      no_of_division: Number(payload.no_of_division || 0),
      per_division_teams: Number(payload.per_division_teams || 0),
      locations: payload.location ? (function (loc) {
        return loc.map((lc) => ({
          location_id: lc.location.id,
          field_id: lc.fields.filter(x => x && x.id).map(x => x.id).join(','),
        }));
      }(payload.location)) : null,
      indv_reg_fees: Number(payload.indv_reg_fees || 0),
    }
    const objectSome = (key) => {
      if (key === 'men_per_team' || key === 'women_per_team' || key === 'indv_reg_fees') {
        return false;
      }

      if (key === 'no_of_division' && data[key] > 4) {
        return true;
      }
      if (key === 'per_division_teams' && data[key] > 16) {
        return true;
      }
      if (key === 'per_division_teams' || key === 'no_of_division') {
        return false;
      }
      if (typeof data[key] === 'string') {
        return !(data[key] || '').trim();
      }
      if (typeof data[key] === 'number' && key !== 'for_feit_fees') {
        return !data[key];
      }
      if (typeof data[key] === 'object' && Array.isArray(data[key])) {
        return !data[key].length;
      }
    };
    if (Object.keys(data).some(objectSome)) {
      return;
    }

    if (props.location.state && props.location.state.league_id) {
      axiosApi.put(`${config.apiUrl}/leagues/${Number(props.location.state.league_id)}`, data).then((resp) => {
        history.push('/admin/leagues', {
          season_id: season_id ? season_id : 0,
        });
        setFormSubmitted(false);
      }).catch((err) => {
        console.error(err);
        setFormSubmitted(false);
      });
      return;
    }

    axiosApi.post(`${config.apiUrl}/leagues`, data).then((resp) => {
      history.push('/admin/leagues', {
        season_id: props.location.state.season_id ? props.location.state.season_id : (season_id ? season_id : 0),
        season_name: props.location.state.season_name ? props.location.state.season_name : '',
      });
      setFormSubmitted(false);
    }).catch((err) => {
      console.error(err);

    });
  }

  const getLeague = (league_id) => {
    axiosApi.get(`${config.apiUrl}/leagues/${league_id}`).then((resp) => {
      if (resp.data && resp.data.data) {
        resp.data.data.reg_deadline = moment(resp.data.data.reg_deadline, 'YYYY-MM-DD').toDate();
        resp.data.data.start_date = moment(resp.data.data.start_date, 'YYYY-MM-DD').toDate();
        resp.data.data.season_name = resp.data.data.season.name;
        resp.data.data.title = resp.data.data.sport.title;
        resp.data.data.sport_id = resp.data.data.sport.id;
        resp.data.data.gender = GENDER[resp.data.data.gender];
        setLeagueScheduleInfo(resp.data.data);
        setPayload({ ...resp.data.data });
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  const getLevelOfPlay = () => {
    axiosApi.get(`${config.apiUrl}/level-of-play`).then((res) => {
      if (res.data.data) {
        const data = res.data.data.filter(obj => {
          if (typeof obj.slug === 'string') {
            obj.slug = capitaLizeString(obj.slug || '');
          }
          return !!obj.slug;
        });
        setPlayLevel(data);
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  return <>
    <div className="addLeague-wrapper">
      <div className="top-blk">
        <Link to={{
          pathname: props.location.state && props.location.state.from && props.location.state.from === 'league_settings_group' ? `/admin/leagues/teams/league-settings` : '/admin/leagues',
          search: props && props.location && props.location.state && props.location.state.league_id ? `?leagueId=${props.location.state.league_id}${season_id ? `&season_id=${season_id}` : ''}` : season_id ? `?season_id=${season_id}` : '',
          state: {
            season_id: props && props.location && props.location.state && props.location.state.season_id ? props.location.state.season_id : (season_id ? season_id : 0),
            season_name: props && props.location && props.location.state && props.location.state.season_name ? props.location.state.season_name : '',
            league_id: props.location.state && props.location.state.league_id ? props.location.state.league_id : 0,
          }
        }}><button className="back-btn"><img src={back} alt='back-icon' />Back to {props.location.state && props.location.state.league_id ? 'League' : 'Overview'}</button></Link>
        <div className="heading-blk">
          <h2>Add a League to Season "{payload.season_name}"</h2>
          <span onClick={(e) => popupHandler(e, 'change_season')}>Change Season</span>
        </div>
        <div className='setting-section'>
          <div className="input-blk">
            <div className="input-field">
              <label>Name<sup>*</sup></label>
              <input
                type="text"
                placeholder="Enter league name"
                value={payload.name}
                onChange={(e) => handleModalCloseResponse({ type: 'name', data: e.target.value })}
              />
              {!payload.name?.trim() && formSubmitted && <span className="error">{messages.league_name_error}</span>}
            </div>
            <div className="input-wrapper">
              <CustomSelect
                uniqueKey={'sports-key'}
                required={true}
                data={sports}
                label={'Sport'}
                placeholder={payload.title ? payload.title : 'Select sport'}
                type={'sport_id'}
                onSelect={onSelect}
                selector="title"
              />
              {!payload?.sport_id && formSubmitted && <span className="error">{messages.sport_error}</span>}
            </div>
            <div className="modifyblock">
              <Link to="/admin/leagues/sports"><button className="modify-btn">Modify/Add Sports and Rules</button></Link>
            </div>
            <div className="input-field">
              <label>Registration Deadline<sup>*</sup></label>
              <div className="date-blk">
                <div className="calendar-blk">
                  <img src={calendar} alt='calendar-icon' />
                </div>
                <DatePicker
                  placeholderText={'MM/DD/YYYY'}
                  minDate={new Date()}
                  maxDate={payload.start_date - 1}
                  selected={payload.reg_deadline}
                  onChange={(date) => handleModalCloseResponse({ type: 'reg_deadline', data: date })}
                />
              </div>
              {!payload.reg_deadline && formSubmitted && <span className="error">{messages.reg_deadline_error}</span>}
            </div>
            <div className="input-field">
              <label>Start Date<sup>*</sup></label>
              <div className="date-blk">
                <div className="calendar-blk">
                  <img src={calendar} alt='calendar-icon' />
                </div>
                <DatePicker
                  placeholderText={'MM/DD/YYYY'}
                  minDate={payload.reg_deadline ? moment(payload.reg_deadline).add(1, 'days').toDate() : new Date()}
                  selected={payload.start_date}
                  onChange={(date) => handleModalCloseResponse({ type: 'start_date', data: date })}
                />
              </div>
              {!payload.start_date && formSubmitted && <span className="error">{messages.start_date_error}</span>}
            </div>
            <div className="input-field">
              <label>Team Registration Fee<sup>*</sup></label>
              <div className="arrow-blk">
                <img src="" alt='' />
              </div>
              <input
                type="number"
                placeholder="0.00"
                min="0"
                value={payload.reg_fees}
                onChange={(e) => handleModalCloseResponse({ type: 'reg_fees', data: e.target.value })}
              />
              {!Number(payload.reg_fees || 0) && formSubmitted && <span className="error">{messages.reg_fees_error}</span>}
            </div>
            <div className="input-field">
              <label>Individual Registration Fee </label>
              <div className="arrow-blk">
                <img src="" alt='' />
              </div>
              <input
                type="number"
                placeholder="0.00"
                min="0"
                value={payload.indv_reg_fees}
                onChange={(e) => {
                  handleModalCloseResponse({ type: 'indv_reg_fees', data: e.target.value })
                }}
              />
              {/* {!Number(payload.indv_reg_fees || 0) && formSubmitted && <span className="error">{messages.indv_reg_fees_error}</span>} */}
            </div>
            <div className="input-field">
              <label>Forfeit Fee</label>
              <input
                type="number"
                min="0"
                placeholder="0.00"
                value={payload.for_feit_fees}
                onChange={(e) => handleModalCloseResponse({ type: 'for_feit_fees', data: e.target.value })}
              />
            </div>
            <div className="input-field">
              <label>Max Teams<sup>*</sup></label>
              <input
                type="number"
                min="1"
                placeholder="Enter max teams."
                value={payload.team_size ? payload.team_size : null}
                onChange={(e) => handleModalCloseResponse({ type: 'team_size', data: e.target.value })}
              />
              {!payload.team_size && formSubmitted && <span className="error">{messages.team_error}</span>}
            </div>
            <div className="input-wrapper">
              <CustomSelect
                required={true}
                uniqueKey={'play-level-key'}
                data={playLevel}
                label={'Level of Play'}
                placeholder={payload.play_level ? payload.play_level : 'Select Level'}
                type={'play_level'}
                onSelect={(data, type) => {
                  if (data) {
                    setPayload(prevData => ({
                      ...prevData,
                      [type]: data.slug,
                    }));
                  }
                }}
                selector="slug"
              />
              {!payload.play_level && formSubmitted && <span className="error">{messages.level_error}</span>}
            </div>
            {/* <div className="input-wrapper">
              <CustomSelect
                required={true}
                uniqueKey={'team-size-key'}
                data={teamSize}
                label={'Team Size'}
                placeholder={payload.team_size ? payload.team_size : 'Select team size'}
                type={'team_size'}
                onSelect={onSelect}
                selector="title"
              />
              {!payload.team_size && formSubmitted && <span className="error">{messages.team_error}</span>}
            </div> */}
            <div className="input-wrapper">
              <CustomSelect
                required={true}
                uniqueKey={'gender-key'}
                data={gender}
                label={'Gender'}
                placeholder={payload.gender ? payload.gender : 'Select Gender'}
                type={'gender'}
                onSelect={onSelect}
                selector="title"
              />
              {!payload.gender && formSubmitted && <span className="error">{messages.gender_error}</span>}
            </div>
            <div className="input-group">
              <div className="input-field">
                <label>Min Number of men per team</label>
                <input
                  type="number"
                  placeholder="0"
                  min="0"
                  value={payload.men_per_team}
                  onChange={(e) => handleModalCloseResponse({ type: 'men_per_team', data: e.target.value })}
                />
              </div>
              <div className="input-field">
                <label>Min Number of women per team</label>
                <input
                  type="number"
                  placeholder="0"
                  min="0"
                  value={payload.women_per_team}
                  onChange={(e) => handleModalCloseResponse({ type: 'women_per_team', data: e.target.value })}
                />
              </div>
            </div>
            <div className={`schedule-loc-time-section`}>
              <LeagueLocationScheduleSection data={leagueScheduleInfo} formSubmitted={formSubmitted} onChange={handleModalCloseResponse} />
            </div>
            <div className="input-wrapper">
              <CustomSelect
                required={true}
                key={'elimination-key'}
                data={eliminationType}
                label={'Elimination type'}
                placeholder={payload.elimination_type ? payload.elimination_type : 'Select Elimination Type'}
                type={'elimination_type'}
                onSelect={onSelect}
                selector="title"
              />
              {!payload.elimination_type && formSubmitted && <span className="error">{messages.elimination_error}</span>}
            </div>
            <div className="input-wrapper">
              <CustomSelect
                required={true}
                uniqueKey={'hosted-by'}
                data={hostedBy}
                label={'Hosted By'}
                placeholder={payload.hosted_by ? HOSTED_BY[payload.hosted_by] : 'Select Hosted By'}
                type={'hosted_by'}
                onSelect={onSelect}
                selector="title"
              />
              {!payload.hosted_by && formSubmitted && <span className="error">{messages.hosted_error}</span>}
            </div>
            <div className="input-field">
              <label>Number of Games/Team<sup>*</sup></label>
              <input
                type="number"
                placeholder="0"
                min="0"
                value={payload.no_of_games}
                onChange={(e) => handleModalCloseResponse({ type: 'no_of_games', data: e.target.value })}
              />
              {!Number(payload.no_of_games || 0) && formSubmitted && <span className="error">{messages.games_error}</span>}
            </div>
            <div className="input-field">
              <label>Number of Weeks<sup>*</sup></label>
              <input
                type="number"
                placeholder="0"
                min="0"
                value={payload.no_of_weeks}
                onChange={(e) => handleModalCloseResponse({ type: 'no_of_weeks', data: e.target.value })}
              />
              {!Number(payload.no_of_weeks || 0) && formSubmitted && <span className="error">{messages.weeks_error}</span>}
            </div>
            <div className="input-field">
              <label>Number of Division</label>
              <input
                type="number"
                placeholder="0"
                min="0"
                max="4"
                value={payload.no_of_division}
                onChange={(e) => handleModalCloseResponse({ type: 'no_of_division', data: e.target.value })}
              />
              {payload.no_of_division > 4 && formSubmitted && <span className="error">{messages.division_error}</span>}
            </div>
            <div className="input-field">
              <label>Per Division Team</label>
              <input
                type="number"
                placeholder="16"
                min="0"
                value={payload.per_division_teams}
                onChange={(e) => handleModalCloseResponse({ type: 'per_division_teams', data: e.target.value })}
              />
              {payload.per_division_teams > 16 && formSubmitted && <span className="error">{messages.per_division_error}</span>}
            </div>
          </div>


        </div>
      </div>
      <div className="footer-blk">
        <button onClick={handleSaveLeague}>Save League</button>
      </div>
    </div>
    <Popup className={type === 'time_slots' ? 'overflow-container' : ''} closeOnDocumentClick={false} open={open}>
      {modalContent}
    </Popup>
  </>
}